<section *ngIf="usage">
    <div class="name-section">
        <h2>{{ nickName }}</h2>
        <span>{{ lineNumber | phone }}</span>
        <span class="date">{{ cycleDate }}</span>
    </div>
    <div class="usage">
        <div class="selection">
            <label class="label" id="usage-detail-title">Activity</label>
            <xm-dropdown
                [optionsList]="activityOptions"
                [ariaLabelId]="'usage-detail-title'"
                [placeholder]="'Select'"
                [scrollHeight]="'100px'"
                (onCollapse)="changeActivity($event)"></xm-dropdown>
            <div class="info" *ngIf="isCallsActivity">
                <h3>{{ usage.domesticVoiceCounts }} {{ pageData.callsLabel }}</h3>
                <p class="uppercase">{{ pageData.unlimitedTalk }}</p>
            </div>
            <div class="info" *ngIf="isCallsToNonUSActivity">
                <h3>{{ usage.internationalVoiceCounts }} {{ pageData.callsLabel }}</h3>
                <p>{{ usage.internationalVoiceDuration }} {{ pageData.minutesLabel }}</p>
                <p class="uppercase">{{ usage.internationalVoiceCost | xmCurrency }} {{ pageData.totalLabel }} <span>{{ pageData.ratesVary }}</span></p>
            </div>
            <div class="info" *ngIf="isCallsWhileOutofUSActivity">
                <h3>{{ usage.roamingVoiceCounts }} {{ pageData.callsLabel }}</h3>
                <p>{{ usage.roamingVoiceDuration }} {{ pageData.minutesLabel }}</p>
                <p class="uppercase">{{ usage.roamingVoiceCost | xmCurrency }} {{ pageData.totalLabel }} <span>{{ pageData.ratesVary }}</span></p>
            </div>
            <div class="info" *ngIf="isMessagesActivity">
                    <h3>{{ usage.domesticMessageCounts }} {{ pageData.messagesLabel }}</h3>
                    <p class="uppercase">{{ pageData.unlimitedMessage }}</p>
            </div>
            <div class="info" *ngIf="isMessagesToNonUsActivity">
                <h3>{{ usage.internationalMessageCounts }} {{ pageData.messagesLabel }}</h3>
                <p class="uppercase">{{ usage.internationalMessageCost | xmCurrency }} {{ pageData.totalLabel }} <span>{{ pageData.ratesVary }}</span></p>
            </div>
            <div class="info" *ngIf="isMessagesWhileOutofUSActivity">
                <h3>{{ usage.roamingMessageCounts }} {{ pageData.messagesLabel }}</h3>
                <p>{{ usage.roamingMessageCost | xmCurrency }} {{ pageData.totalLabel }} <span>{{ pageData.ratesVary }}</span></p>
            </div>
            <div class="info" *ngIf="isDataWhileOutofUSActivity">
                <h3 class="uppercase">{{ roamingDataConsumed }} {{ pageData.dataUnit }}</h3>
                <p class="uppercase">{{ usage.roamingDataCost | xmCurrency }} {{ pageData.totalLabel }} <span>{{ pageData.ratesVary }}</span></p>
            </div>
            <div class="info" *ngIf="isCallsToMexAndCan">
                <h3>{{ usage.mexCanCalls }} {{ pageData.callsLabel }}</h3>
                <p>{{ usage.mexCanVoiceDuration }} {{ pageData.minutesLabel }}</p>
                <p class="uppercase">{{ usage.mexCanCallCost | xmCurrency }} {{ pageData.totalLabel }} <span>{{ pageData.ratesVary }}</span></p>
            </div>
            <div class="travel-pass" *ngIf="gtpSessions?.length">
                <h3 [ngPlural]="gtpSessions.length">
                    <ng-template ngPluralCase="1">{{ pageData.globalTravelPassSingularHeader }}</ng-template>
                    <ng-template ngPluralCase="other">{{ gtpSessions.length }} {{ pageData.globalTravelPassPluralHeader }}</ng-template>
                </h3>
                <div class="pass-details" *ngFor="let session of gtpSessions; let last = last"  [ngClass]="{ last: last }">
                    <p class="country" *ngIf="cmsCountryCode[session.countryCode]">{{ cmsCountryCode[session.countryCode] }}, {{ formatGtpPassStartDate(session.startTime) }}</p>
                    <p class="pass-dates"><span>{{ pageData.startDateLabel }} {{ formatGtpPassStartEndTime(session.startTime) }}</span><span>{{ pageData.endDateLabel }} {{ formatGtpPassStartEndTime(session.endTime) }}</span></p>
                </div>
            </div>
            <button class="search-country-cta xm-btn-secondary-dark" *ngIf="(lineSummary && (!isCallsActivity && !isMessagesActivity))" (click)="searchCountryCta()">{{ pageData.searchByCountry }}</button>
        </div>
        <div class="usage-list">
            <div  class="group" *ngFor="let group of activities | keys">
                <h4>{{ group }}</h4>
                <ul class="group-item" *ngFor="let call of activities[group]">
                    <xm-media-image [imageOptions]="buildIcon(call)" center="auto" size="auto"></xm-media-image>
                    <li *ngIf="isCallsActivity">
                        <p class="phone">
                            <span>{{ call.phone | phone }}</span>
                        </p>
                        <p class="location">
                            <span *ngIf="call.location">{{ call.location | titlecase }},&nbsp;</span><span>{{ call.time }}</span>
                            <span [ngPlural]="call.duration">
                                <ng-template  ngPluralCase="1">{{ call.duration }} {{ pageData.singularCallUnit }}</ng-template>
                                <ng-template  ngPluralCase="other">{{ call.duration }} {{ pageData.pluralCallUnit }}</ng-template>
                            </span>
                        </p>
                    </li>
                    <li *ngIf="isCallsToNonUSActivity">
                        <p class="phone">
                            <span>{{ call.phone | phone }}</span>
                            <span>{{ call.cost | xmCurrency }}</span>
                        </p>
                        <p class="location">
                            <span *ngIf="call.location">{{ call.location | titlecase }},&nbsp;</span><span>{{ call.time }}</span>
                            <span [ngPlural]="call.duration">
                                <ng-template  ngPluralCase="1">{{ call.duration }} {{ pageData.singularCallUnit }}</ng-template>
                                <ng-template  ngPluralCase="other">{{ call.duration }} {{ pageData.pluralCallUnit }}</ng-template>
                            </span>
                        </p>
                    </li>
                    <li *ngIf="isCallsWhileOutofUSActivity">
                        <p class="phone">
                            <span>{{ call.phone | phone }}</span>
                            <span>{{ call.cost | xmCurrency }}</span>
                        </p>
                        <p class="location">
                            <span *ngIf="call.location">{{ call.location | titlecase }},&nbsp;</span><span>{{ call.time }}</span>
                            <span [ngPlural]="call.duration">
                                <ng-template  ngPluralCase="1">{{ call.duration }} {{ pageData.singularCallUnit }}</ng-template>
                                <ng-template  ngPluralCase="other">{{ call.duration }} {{ pageData.pluralCallUnit }}</ng-template>
                            </span>
                        </p>
                    </li>
                    <li *ngIf="isMessagesActivity">
                        <p class="phone">
                            <span>{{ call.phone | phone }}</span>
                        </p>
                        <p class="location">
                            <span *ngIf="call.location">{{ call.location | titlecase }},&nbsp;</span><span>{{ call.time }}</span>
                            <span>{{ call.messageType }}</span>
                        </p>
                    </li>
                    <li *ngIf="isMessagesToNonUsActivity">
                        <p class="phone">
                            <span>{{ call.phone | phone }}</span>
                            <span>{{ call.cost | xmCurrency }}</span>
                        </p>
                        <p class="location">
                            <span *ngIf="call.location">{{ call.location | titlecase }},&nbsp;</span><span>{{ call.time }}</span>
                            <span>{{ call.messageType }}</span>
                        </p>
                    </li>
                    <li *ngIf="isMessagesWhileOutofUSActivity">
                        <p class="phone">
                            <span>{{ call.phone | phone }}</span>
                            <span>{{ call.cost | xmCurrency }}</span>
                        </p>
                        <p class="location">
                            <span *ngIf="call.location">{{ call.location | titlecase }},&nbsp;</span><span>{{ call.time }}</span>
                            <span>{{ call.messageType }}</span>
                        </p>
                    </li>
                    <li *ngIf="isDataWhileOutofUSActivity">
                        <p class="phone">
                            <span *ngIf="call.location">{{ call.location | titlecase }},&nbsp;</span><span>{{ call.time }}</span>
                            <span>{{ call.dataUsed }} {{ pageData.dataUnit }}</span>
                        </p>
                    </li>
                    <li *ngIf="isCallsToMexAndCan">
                        <p class="phone">
                            <span>{{ call.phone | phone }}</span>
                            <span>{{ call.cost | xmCurrency }}</span>
                        </p>
                        <p class="location">
                            <span *ngIf="call.location">{{ call.location | titlecase }},&nbsp;</span><span>{{ call.time }}</span>
                            <span [ngPlural]="call.duration">
                                <ng-template  ngPluralCase="1">{{ call.duration }} {{ pageData.singularCallUnit }}</ng-template>
                                <ng-template  ngPluralCase="other">{{ call.duration }} {{ pageData.pluralCallUnit }}</ng-template>
                            </span>
                        </p>
                    </li>
                    <li *ngIf="isGlobalTravelPass || isMexCanTravelPass">
                        <!-- For Calls -->
                        <p class="phone" *ngIf="call.isPhoneCall">
                            <span>{{ call.phone | phone }}</span>
                        </p>
                        <p class="location" *ngIf="call.isPhoneCall">
                            <span *ngIf="call.location">{{ call.location | titlecase }},&nbsp;</span><span>{{ call.time }}</span>
                            <span [ngPlural]="call.duration">
                                <ng-template  ngPluralCase="1">{{ call.duration }} {{ pageData.singularCallUnit }}</ng-template>
                                <ng-template  ngPluralCase="other">{{ call.duration }} {{ pageData.pluralCallUnit }}</ng-template>
                            </span>
                        </p>

                        <!-- For Messages -->
                        <p class="phone" *ngIf="call.isMessage">
                            <span>{{ call.phone | phone }}</span>
                        </p>
                        <p class="location" *ngIf="call.isMessage">
                            <span *ngIf="call.location">{{ call.location | titlecase }},&nbsp;</span><span>{{ call.time }}</span>
                            <span>{{ call.messageType }}</span>
                        </p>

                        <!-- For Data -->
                        <p class="phone" *ngIf="call.dataUsed">
                            <span *ngIf="call.location">{{ call.location | titlecase }},&nbsp;</span><span>{{ call.time }}</span>
                            <span class="data-usage">{{ call.dataUsed }} {{ pageData.dataUnit }}</span>
                        </p>
                    </li>
                </ul>
            </div>
            <!-- <button class="button xm-btn-secondary-dark">Show More</button> -->
        </div>
    </div>
</section>

<xm-display-card *ngIf="!usage">
    <xm-loader-overlay type="usage"></xm-loader-overlay>
</xm-display-card>
